import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { notification } from 'antd';
import axios from 'axios';
import { CheckCircleFilled, } from '@ant-design/icons';


import { normalizeUpsertCustomLensResponse } from 'components/molecules/PPA/Modals/CustomLense/customLens.helpers';
import type {
    CreateCustomLensRequest,
    UpsertCustomLensResponse,
} from 'components/molecules/PPA/Modals/CustomLense/customLens.types';
import { ppaUrls } from 'config/urls';
import { PricingSimulatorNotificationMessages } from 'utils/Enums';
import { sendNotification } from 'utils/helperMethods';
import { createElement } from 'react';

 
type UseUpsertCustomLensResult = {
    loading: boolean;
    mutate: UseMutateFunction<
        UpsertCustomLensResponse,
        Error,
        CreateCustomLensRequest,
        unknown
    >;
};

export function useUpsertCustomLens(): UseUpsertCustomLensResult {
    const { isPending, isPaused, mutate } = useMutation({
        mutationFn: async (payload: CreateCustomLensRequest) => {
            const response = await axios.post<UpsertCustomLensResponse>(
                ppaUrls.createCustomLensUrl,
                payload,
            );
            return normalizeUpsertCustomLensResponse(response.data) ?? response.data;
        },
        onSuccess: (_data, payload) => {
            notification.success({
                duration: 5,
                icon: createElement(CheckCircleFilled, {
                    style: { position: 'relative', top: -3, color: '#52C41A' },
                }),
                message: PricingSimulatorNotificationMessages.CREATE_CUSTOM_LENS_SUCCESS_TITLE,
                description: `"${payload.lens_name}"`,
                style: { width: 350, height: 'auto', borderRadius: 8 },
            });
        },
        onError: () => {
            sendNotification('error', PricingSimulatorNotificationMessages.LENS_CONFIG_FAILED);
        },
    });

    return {
        loading: isPending || isPaused,
        mutate,
    };
}

export default useUpsertCustomLens;
